import type { FC, ReactNode } from 'react'
import type { JsonLdNode } from '@/types'

interface JsonLdProps {
    data: JsonLdNode
}

// Renders a server-side JSON-LD <script>. The `<` escape prevents the
// serialized JSON from ever breaking out of the script element.
export const JsonLd: FC<JsonLdProps> = ({ data }): ReactNode => {
    const json = JSON.stringify(data).replace(/</g, '\\u003c')

    return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: json }} />
}
